import SpamPageLayout from './SpamPageLayout';

export default SpamPageLayout;
